import type {ReactElement, SyntheticEvent} from 'react';
import type {IconSize} from '@Components/icon-v2/icon.types';
import type {TextSize} from '@Components/text';

export enum TabSeparatorIcon {
  NONE = 'none',
  CARET_RIGHT = 'icon-caret-right',
}

export enum TabContentWidth {
  AUTO = 'auto',
  STRETCHED = 'stretched',
}

export enum TabContentLayout {
  BLOCK = 'block',
  FLEX = 'flex',
}

/** Marks the selected tab; the Tabs slider measures the first element carrying it. */
export const TAB_ACTIVE_CLASS = 'js-tab-active';

export type TabKey = string;
export type TabItems = TabItemContentStorage[];

export type TabClickHandler = (tabKey: TabKey, e: SyntheticEvent) => void;

export interface TabTitle {
  text: string;
  preTitleContent?: ReactElement<any>;
  postTitleContent?: ReactElement<any>;
}

export interface TabItemContentStorage extends TabTitle {
  tabKey: TabKey;
  href?: string;
  containerClassName?: string;
  textClassName?: string;
  className?: string;
  selectedClassName?: string;
  showPremiumCrown?: boolean;
  disabled?: boolean;
  disableSelection?: boolean;
  extraElementAfterTab?: ReactElement<any>;
  extraElementContainerClassName?: string;
}

export interface TabItemContentHandlers {
  href?: string;
  onClick?: (e: SyntheticEvent) => void;
}

/** What a custom renderer gets in place of the default "more" dropdown: the folded tabs, the selection and the click handler. */
export interface MoreOptionsRenderProps {
  items: TabItems;
  selectedTabKey: TabKey;
  onTabItemClick: TabClickHandler;
}

export type MoreOptionsRenderer = (props: MoreOptionsRenderProps) => ReactElement;

export interface TabsMoreOptionsConfig {
  iconSize: IconSize;
  textSize?: TextSize;
  textClasses?: string;
  className?: string;
  containerClassName?: string;
}

export enum TabsThemes {
  DEFAULT = 'default',
  DARK = 'dark',
  PRIMARY_LIGHT = 'primary-light',
  GRADIENT = 'gradient',
}

export enum TabSliderType {
  NONE = 'none',
  SLIDER_LINE = 'line',
  SLIDER_BLOCK = 'block',
}
